import MuiButton, { type ButtonProps as MuiButtonProps } from '@mui/material/Button';

export type ButtonVariant = 'primary' | 'google' | 'text';

export type ButtonProps = Omit<MuiButtonProps, 'variant'> & {
  variant?: ButtonVariant;
};

const controlHeight = 40;
const radius = 6;

export function Button({ variant = 'primary', sx, fullWidth, children, ...rest }: ButtonProps) {
  if (variant === 'google') {
    return (
      <MuiButton
        disableElevation
        fullWidth={fullWidth}
        sx={{
          height: controlHeight,
          borderRadius: `${radius}px`,
          px: 2,
          py: 0,
          textTransform: 'none',
          fontWeight: 400,
          fontSize: 11,
          lineHeight: '23.375px',
          color: '#1e2a39',
          bgcolor: 'rgba(240, 240, 240, 0.58)',
          border: 'none',
          '&:hover': { bgcolor: 'rgba(230, 230, 230, 0.75)' },
          ...sx,
        }}
        {...rest}
      >
        {children}
      </MuiButton>
    );
  }

  if (variant === 'text') {
    return (
      <MuiButton
        variant="text"
        disableElevation
        fullWidth={fullWidth}
        sx={{
          minHeight: controlHeight,
          borderRadius: `${radius}px`,
          px: 1,
          py: 0.5,
          textTransform: 'none',
          fontSize: 11,
          ...sx,
        }}
        {...rest}
      >
        {children}
      </MuiButton>
    );
  }

  return (
    <MuiButton
      variant="contained"
      disableElevation
      fullWidth={fullWidth}
      sx={{
        height: controlHeight,
        borderRadius: `${radius}px`,
        py: 0,
        textTransform: 'none',
        fontWeight: 500,
        fontSize: 12,
        lineHeight: '23.375px',
        bgcolor: '#1e2a39',
        color: '#fff',
        '&:hover': { bgcolor: '#15202c' },
        '&:disabled': { bgcolor: 'rgba(30, 42, 57, 0.4)', color: '#fff' },
        ...sx,
      }}
      {...rest}
    >
      {children}
    </MuiButton>
  );
}
